export const calcListHeight = (p: { count: number; itemHeight: number; gapHeight?: number }) => {
  const { count, itemHeight, gapHeight = 0 } = p

  return count * itemHeight + count * gapHeight - gapHeight
}
